import {
  FETCH_SUCCESS,
  FETCH_ERROR,
  GET_LIST_HUYEN,
  GET_LIST_XA,
  GET_LIST_DON_VI_BY_ID
} from 'constants/ActionTypes';
import { setLocalStorage, removeLocalStorage } from 'src/util/Common';

import Helper from 'src/helpers';
import { messages } from 'src/constants/messages';

// Saga effects
import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { danhMucDungChungAPI } from './Api';

// Lấy danh sách huyện
const fetchDanhMucHuyen = function* fetchDanhMucHuyen(data) {
  try {
    const { maDonVi } = data.payload;
    const receivedData = yield danhMucDungChungAPI.fetchDanhMuc(maDonVi);
    // Lưu và cookie
    const saveData = {
      data: receivedData.data,
      status: receivedData.status
    };
    if (receivedData.status === 500) {
      Helper.alertError(`${messages.LOI_HE_THONG} Không thể tải về danh mục huyện`);
    } else {
      setLocalStorage('dsHuyen', saveData);
    }
  } catch (error) {
    removeLocalStorage('dsHuyen');
  }
};

export const watchFetchDanhMucHuyen = function* watchFetchDanhMucHuyen() {
  yield takeLatest(GET_LIST_HUYEN, fetchDanhMucHuyen);
};

const fetchDanhMucXa = function* fetchDanhMucXa(data) {
  try {
    const receivedData = yield danhMucDungChungAPI.fetchDanhMuc(data.maDonVi);
    yield put({
      type: FETCH_SUCCESS,
      data: receivedData.data,
      status: receivedData.status
    });
  } catch (error) {
    yield put({
      type: FETCH_ERROR,
      error
    });
  }
};

export const watchFetchDanhMucXa = function* watchFetchDanhMucXa() {
  yield takeEvery(GET_LIST_XA, fetchDanhMucXa);
};

const fetchDanhMucById = function* fetchDanhMucById(data) {
  try {
    const receivedData = yield danhMucDungChungAPI.fetchDanhMucById(data.maDonVi);
    yield put({
      type: FETCH_SUCCESS,
      data: receivedData.data,
      status: receivedData.status
    });
  } catch (error) {
    yield put({
      type: FETCH_ERROR,
      error
    });
  }
};

export const watchFetchDanhMucById = function* watchFetchDanhMucById() {
  yield takeEvery(GET_LIST_DON_VI_BY_ID, fetchDanhMucById);
};
